import * as React from 'react';

import { Tooltip as TooltipPrimitive } from 'radix-ui';
import { cn } from '~/components/ui/cn';

const TooltipProvider: React.FC<
  React.ComponentProps<typeof TooltipPrimitive.TooltipProvider>
> = ({ ...props }) => (
  <TooltipPrimitive.Provider
    delayDuration={props.delayDuration ?? 0}
    {...props}
  />
);

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent: React.FC<
  React.ComponentProps<typeof TooltipPrimitive.Content>
> = ({ className, sideOffset = 4, ...props }) => (
  <TooltipPrimitive.Content
    sideOffset={sideOffset}
    className={cn(
      'z-50 rounded-md bg-gray-900 px-3 py-1.5 text-sm text-white shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
      className,
    )}
    {...props}
  />
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const TooltipArrow: React.FC<
  React.ComponentProps<typeof TooltipPrimitive.TooltipArrow>
> = ({ ...props }) => (
  <TooltipPrimitive.TooltipArrow
    width={props.width ?? 16}
    height={props.height ?? 8}
    {...props}
  />
);

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipArrow,
};
